module.exports = {"230805007":"晓云街道","230805008":"佳东街道","230805009":"建国街道","230805010":"佳南街道","230805100":"建国镇","230805200":"松江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230805.json
// module id = 857
// module chunks = 0